import themeColors from '@/assets/theme/colors'

const classes = {
  mainDiv: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '3rem',
    paddingBottom: '3rem'
  },
  sndDiv: {
    maxWidth: 900,
    padding: '1.25rem'
  },
  h1: {
    marginTop: '2rem',
    marginBottom: '1rem',
    color: themeColors.gray.dark
  },
  h2: {
    marginTop: '2rem',
    marginBottom: '0.6rem',
    fontWeight: 700,
    color: themeColors.gray.dark
  },
  b1: {
    fontSize: '0.93rem',
    color: themeColors.gray.mid
  },
  b2: {
    color: themeColors.gray.mid,
    lineHeight: 1.7,
    marginBottom: '0.5rem'
  }
}

export default classes
